import toast from 'react-hot-toast';

/**
 * Extracts a user-friendly error message from any API error or validation error response.
 */
export const extractApiErrorMessage = (error, fallback = 'An unexpected error occurred.') => {
  if (!error) return fallback;

  if (typeof error === 'string') return error;

  const data = error.response?.data || error.data;

  // 1. Check for express-validator array of errors
  if (Array.isArray(data?.errors) && data.errors.length > 0) {
    const errorList = data.errors
      .map((err) => {
        if (typeof err === 'string') return err;
        if (err?.message) return err.message;
        if (err?.msg) return err.msg;
        return '';
      })
      .filter(Boolean);

    if (errorList.length > 0) {
      const details = errorList.join(', ');
      if (data.message && !data.message.toLowerCase().includes('validation failed')) {
        return `${data.message}: ${details}`;
      }
      return details;
    }
  }

  // 2. Check for object dictionary of errors { field: 'message' }
  if (data?.errors && typeof data.errors === 'object' && !Array.isArray(data.errors)) {
    const messages = Object.values(data.errors).filter(Boolean);
    if (messages.length > 0) {
      return messages.join(', ');
    }
  }

  // 3. Direct message from server
  if (data?.message) return data.message;
  if (data?.error) return typeof data.error === 'string' ? data.error : data.error?.message || fallback;

  // 4. Fallback to client error message
  if (error.message) {
    if (error.message === 'Network Error') return 'Unable to connect to server. Please check your network connection.';
    return error.message;
  }

  return fallback;
};

/**
 * Display a deduplicated error toaster
 */
export const showApiErrorToast = (error, fallback) => {
  const message = extractApiErrorMessage(error, fallback);
  if (message) {
    toast.error(message, { id: message });
  }
  return message;
};

export default {
  extractApiErrorMessage,
  showApiErrorToast
};
